// extracted by mini-css-extract-plugin
export default {"btn":"DeletedReservationsRow_btn__Uwv-u","table-number-cell":"DeletedReservationsRow_table-number-cell__xaWmg","tr":"DeletedReservationsRow_tr__KPC9b"};